'use client';

import { cn } from '@/lib/utils';
import { memo, PropsWithChildren, ReactNode } from 'react';
import { RoundLoading } from './custom-round-loading';

type Props = PropsWithChildren<{
    loading?: boolean;
    className?: string;
    size?: 'small' | 'large' | 'medium';
    description?: ReactNode;

    isSticky?: boolean;
}>;

const WrapperLoading = memo((props: Props) => {
    const {
        children,
        loading,
        size = 'small',
        isSticky = false,
        className,
        description,
    } = props;

    return (
        <div className={cn('loading_wrapper relative')}>
            <div className={cn('loading_container', className)}>{children}</div>

            {/* loading */}
            {/* {loading && (
                    <div className='absolute inset-0 z-10 flex flex-col items-center justify-center bg-white/60 dark:bg-secondary'>
                        <div className='flex h-20 w-20 items-center justify-center rounded-full'>
                            <RoundLoading size={size} />
                        </div>
                        {description}
                    </div>
                )} */}

            {loading && (
                <div className='absolute inset-0 z-10 bg-white/60 dark:bg-secondary'>
                    <div
                        className={cn('', {
                            'sticky top-1/2 flex w-full -translate-y-1/2 flex-col items-center justify-center':
                                isSticky,
                            'flex h-full flex-col items-center justify-center':
                                !isSticky,
                        })}
                    >
                        <div className='p-4'>
                            <RoundLoading size={size} />
                        </div>
                        {description}
                    </div>
                </div>
            )}
        </div>
    );
});

WrapperLoading.displayName = 'WrapperLoading';
export { WrapperLoading };
